
export const OVERALLSTATUS = {
    COMPLETE: "COMPLETE",
    INCOMPLETE: "INCOMPLETE",
    INVALID: "INVALID"
};

export const AUSPRAEGUNGSTATUS = {
    SELECTED: "SELECTED",
    NORMAL: "NORMAL",
    EXCLUDED: "EXCLUDED"
};